import { useContext, useEffect } from 'react';

import AppContext from 'context';
import getUserData from 'services/user';

export const useUser = () => {
  const {
    state: {
      user: { isFetching, isFetched, data, error },
    },
    dispatch,
  } = useContext(AppContext);

  const fetchUser = async () => {
    dispatch({ type: 'user_load' });
    try {
      const response = await getUserData();
      dispatch({ type: 'user_load_success', payload: response.data });
    } catch (err) {
      dispatch({ type: 'user_load_err', payload: err });
    }
  };

  useEffect(() => {
    if (!isFetching && !data) {
      fetchUser();
    }
  }, []);

  return {
    isFetched,
    isFetching,
    data,
    error,
    fetchUser,
  };
};

export default useUser;
